module.exports = __webpack_public_path__ + "img/horizontal_3_1_r_pp1_3009.fa74b38e.png";